import {AiFillLinkedin, AiFillGithub} from "react-icons/ai";

export const links = [
    {id: 1, link: "#", title: "Home"},
    {id: 2, link: "#about", title: "About"},
    {id: 3, link: "#specialisations", title: "Specialisations"},
    {id: 4, link: "#portfolio", title: "Portfolio"},
    {id: 5, link: "#contact", title: "Contact"},
];

export const socials = [
    {
        id: 1,
        link: "https://www.linkedin.com/in/oytun-ikiz/",
        icon: <AiFillLinkedin/>,
    },
    {id: 2, link: "https://github.com/MrChelizt", icon: <AiFillGithub/>},
];
